'use es6';

import getIn from 'transmute/getIn';
export const getMessageId = message => getIn(['id'], message) || getIn(['message', 'id'], message) || -1;